'use strict';

module.exports = {
  API_URL: 'https://api.tradeaidata.com',
  FILE_URL: 'https://shs.waimaogongshe.cn',
  BASE_API: 'https://rest.tradesparq.com',
  CONSOLE_URL: 'https://console.tradesparq.com',
  PERMISSION: {
    BRONZE                 : 1,
    SILVER                 : 2,
    GOLD                   : 3,
    PRO                    : 4,
    GLOBAL                 : 5,
    GLOBAL_PLUS            : 6,
    GLOBAL_LUXURY          : 7,
    GLOBAL_DELUXE          : 8,
    PARTNER_REPORT         : 16,
    GLOBAL_BUYERS          : 32,
    TRADE_SO               : 64,
    MARKET_ANALYSIS        : 128
  }
};



// WEBPACK FOOTER //
// ./src/config.js